import React from 'react';
import { Box, Grid, CardContent, Typography, Chip, styled } from '@mui/material';
import { ConditionDetails } from '../../types/genomic';


const StyledConditionCard = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderColor: theme.palette.divider,
  borderLeft: `4px solid ${theme.palette.primary.main}`,

  borderRadius: theme.shape.borderRadius,
  marginTop: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,

  breakInside: 'avoid',

  "& .MuiCardContent-root": {
    padding: "1em !important"
  }
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2),
}));

interface Props {
  condition: ConditionDetails;
}

export const ConditionCard: React.FC<Props> = ({ condition }) => {
  return (
    <StyledConditionCard>
      <StyledCardContent>
        <Grid container>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gap={1} >
              <Typography variant="h6" color="primary">{condition.name}</Typography>
              {condition.mondo_id && (
                <Chip
                  label={`Mondo: ${condition.mondo_id}`}
                  size="small"
                  variant="outlined"
                />
              )}
            </Box>
          </Grid>
          {condition.description && <Typography mt={2} variant="body2" color="text.secondary" sx={{ mb: 2 }}>{condition.description}</Typography>}
          {condition.inheritance_pattern &&
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{condition.inheritance_pattern}</Typography>
          }
          {/*{condition.associated_genes && condition.associated_genes.length > 0 && (
            <Grid item xs={12}>
              <Label>Associated Genes</Label>
              <Box display="flex" gap={1} mt={1} flexWrap="wrap">
                {condition.associated_genes.map((gene, i) => (
                  <Chip key={i} label={gene} size="small" variant="outlined" />
                ))}
              </Box>
            </Grid>
          )}*/}
        </Grid>
      </StyledCardContent>
    </StyledConditionCard>
  );
}; 